import { IAppState } from '../../../AppModulesWrapper';

export const selectMultipostingABGroup = (state: IAppState): null => null;
